import { required } from './required';
export function validatePhone(value) {
    if (!value)
        return '';
    return !/^\+?[0-9]{3,15}$/.test(value) ? 'Enter a valid phone number' : '';
}
export function validateUKPhone(value) {
    if (!value)
        return '';
    return !/^[0-9 ]+$/.test(value) || value.replace(/ /g, '').length !== 11
        ? 'Enter a valid UK phone number'
        : '';
}
export function validatePhoneNoPlus(value) {
    if (!value)
        return '';
    return !/^[0-9]{3,15}$/.test(value) ? 'Enter a valid phone number' : '';
}
export var requiredPhone = required(validatePhone);
export var requiredUKPhone = required(validateUKPhone);
export var requiredPhoneNoPlus = required(validatePhoneNoPlus);
//# sourceMappingURL=validatePhone.js.map